/**
 * Same-tab signal that the session is over. Emitted when /auth/refresh is
 * rejected (401) or when sessionExpiresAt is reached; consumed by AuthContext,
 * which clears state, tells other tabs, and sends the user to /login.
 */
export type SessionExpiredReason = "refresh-rejected" | "session-timeout";

export interface SessionExpiredEvent {
	reason: SessionExpiredReason;
}

type Listener = (event: SessionExpiredEvent) => void;

const listeners = new Set<Listener>();

export function onSessionExpired(listener: Listener): () => void {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
}

export function emitSessionExpired(reason: SessionExpiredReason): void {
	const event: SessionExpiredEvent = { reason };
	for (const listener of Array.from(listeners)) {
		try {
			listener(event);
		} catch (error) {
			console.error("session-expired listener failed", error);
		}
	}
}
